window.addEventListener('DOMContentLoaded', () => {
    const allSuccessStories = document.querySelectorAll('.page-template-archive-success-story .success-story');
    allSuccessStories.forEach((successStory, index) => {
        const link = successStory.querySelector('.wp-block-read-more');
        successStory.addEventListener('click', () => {
            if (link) {
                link.click();
            }
        });
    });

});
